import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { toast } from "react-toastify";

type ErrorData = {
  response: {
    data: {
      message: string;
    };
    status: string;
  };
};

type ErrorDataResponse = {
  message?: string;
};

export const getAccessToken = async (): Promise<string | void> => {
  const req = axios.create({
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Accept-Language": "pt-BR",
      client_id: process.env.REACT_APP_CLIENT_ID,
    },
    baseURL: process.env.REACT_APP_API_URL_OAUTH,
  });

  const header = {
    "Content-Type": "application/json",
    "Accept-Language": "pt-BR",
    Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
  };

  const parameters: AxiosRequestConfig = {
    method: "POST",
    headers: header,
  };
  const body = {
    grant_type: "client_credentials",
  };

  let access_token = "";

  access_token = localStorage.getItem("@UltragazEmpresarial:accessToken");

  if (access_token) return access_token;

  try {
    const response = await req.post("oauth/access-token", body, parameters);
    access_token = response?.data?.access_token || "";
  } catch (error) {
    const erro = error as AxiosError<ErrorDataResponse> | ErrorData;
    const data = erro.response?.data;
    const message = data?.message;

    if (message && erro.response?.status !== 401) {
      toast.error(message);
    } else if (erro.response && erro.response.status !== 401) {
      toast.error("Ocorreu um erro interno na aplicação");
    }
  }

  return access_token;
};
